// extracted by mini-css-extract-plugin
export var statItem = "_c6-1";
export var statsRow = "_c6-0";